// eslint-disable-next-line import/prefer-default-export
export const maxScrollTop = (dom) => dom.scrollHeight - dom.clientHeight;
